
import { Component, Vue, Prop } from "vue-property-decorator";
import ClosedPeriod from "../../../domain/restaurant/ClosedPeriod";
import ClosedPeriodCard from "@/components/restaurant/holiday/ClosedPeriodCard.vue";
import Room from "@/domain/restaurant/Room";
import Restaurant from "@/domain/restaurant/Restaurant";
@Component({
  components: { ClosedPeriodCard }
})
export default class ClosedPeriodList extends Vue {
  @Prop({
    default: () => {
      return [];
    }
  })
  closedPeriodList!: ClosedPeriod[];

  @Prop({ default: null })
  room!: Room | null;

  @Prop({ default: null })
  restaurant!: Restaurant | null;

  mounted() {
    this.closedPeriodList.sort(
      ClosedPeriod.ClosedPeriodByStartDateAscendingComparator
    );
  }

  get isHoliday() {
    return this.room == null && this.restaurant != null;
  }

  addClosedPeriod(newHoliday: ClosedPeriod) {
    this.closedPeriodList.push(newHoliday);
    this.closedPeriodList.sort(
      ClosedPeriod.ClosedPeriodByStartDateAscendingComparator
    );
  }

  removeClosedPeriod(toRemove: ClosedPeriod) {
    const indexToRemove = this.closedPeriodList.indexOf(toRemove);
    if (indexToRemove > -1) {
      this.closedPeriodList.splice(indexToRemove, 1);
    }
  }
}
